// Order detail pages carry an orgId or institutionId that switches the user into the right
// institution on load, so it's safe to return straight there even for multi-institution users.
// Only /orders/<id> itself does this (not nested pages like /orders/<id>/edit), so the path
// match is constrained to a single segment after /orders/.
export function isOrderDetailDeepLink(asPath: string): boolean {
  const isOrderDetailPath = /^\/orders\/[^/?]+(?:\?|$)/.test(asPath);
  return isOrderDetailPath && /[?&](orgId|institutionId)=/.test(asPath);
}
